import React from 'react';
import { Button, Card, Flex, Typography } from 'antd';

import { Prompt } from '../components/Prompt';
import { useAppSelector } from '../../../../../store';
import { useCreateRecommendationMutation } from '../service/recommendation.api';
import { selectAnalyticsFilters } from '../../../store/analyticFiltersSlice';

export const RecommendationContainer = () => {
    const { chat } = useAppSelector(selectAnalyticsFilters);

    const [createRecommendation, { isSuccess, isLoading, data }] =
        useCreateRecommendationMutation();

    return (
        <Card>
            <Flex vertical gap={16}>
                <Flex
                    align={'center'}
                    justify={'space-between'}
                    vertical={false}
                >
                    <Typography.Text>Рекомендации</Typography.Text>

                    <div>
                        <Button
                            disabled={isSuccess}
                            loading={isLoading}
                            onClick={() => createRecommendation(chat)}
                            type={'primary'}
                        >
                            Получить рекомендации
                        </Button>
                    </div>
                </Flex>
                <Prompt data={data} />
            </Flex>
        </Card>
    );
};
